import React from 'react';
import { TableCell as MuiTableCell, TableCellProps as MuiTableCellProps } from '@material-ui/core';
import styled from 'styled-components';

interface TableCellProps {
    isSticky?: boolean;
    isTableHead?: boolean;
    bold?: boolean;
}

const TableCell = styled(({ isSticky, id, isTableHead, bold, ...props }: TableCellProps & MuiTableCellProps) => (
    <MuiTableCell id={id} {...props} />
))`
    ${props => props.isSticky && `
        max-width: 33vw;
        position: sticky; 
        left: 0;
        background-color: inherit;
        border-right: 2px solid  ${props.theme.palette.background.default};
    `}

    ${props => props.isTableHead && `
        background-color: #FFFFFF;
        z-index: 1;
    `}
`;

export default TableCell;
